"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Camel2CSS = function (camel) {
    return camel.replace(/[A-Z]/g, function (str) { return "-" + str.toLowerCase(); }).toLowerCase();
};
var CSSProperties2MediaQuery = function (css) {
    return Object.keys(css)
        .map(function (key) {
        var value = css[key];
        key = Camel2CSS(key);
        switch (typeof value) {
            case 'boolean':
                return value ? "(" + key + ")" : "(not " + key + ")";
            case 'number':
                if (/(?:height|width)$/.test(key))
                    value = value + "px";
            default:
                return "(" + key + ": " + value + ")";
        }
    })
        .join(' and ');
};
exports.default = (function (query) {
    if (typeof query === 'string')
        return query;
    if (!Array.isArray(query))
        return CSSProperties2MediaQuery(query);
    return query.map(CSSProperties2MediaQuery).join(', ');
});
